import * as Types from '../../types';

import { gql } from '@apollo/client';
import { AddressDisplayFragmentDoc } from '../../components/AddressDisplay/AddressDisplay.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTransactionsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filters?: Types.InputMaybe<Array<Types.FilterInput> | Types.FilterInput>;
}>;

export type GetTransactionsQuery = {
  __typename?: 'Query';
  transactions: {
    __typename?: 'TransactionConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'TransactionEdge';
      cursor: string;
      node: {
        __typename?: 'Transaction';
        hash: string;
        nonce: number;
        transactionIndex?: number | null;
        value: Array<number>;
        valueEth: any;
        valueUsd?: any | null;
        gas: number;
        gasPrice?: any | null;
        maxFeePerGas?: any | null;
        maxPriorityFeePerGas?: any | null;
        maxFeePerBlobGas?: any | null;
        input: string;
        chainId?: number | null;
        status: Types.TransactionStatus;
        blockNumber?: number | null;
        blockHash?: string | null;
        createdAt: any;
        to?: {
          __typename?: 'Address';
          address: string;
          entity?: {
            __typename?: 'Entity';
            id: any;
            name: string;
            risks: {
              __typename?: 'EntityRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'EntityRiskEdge';
                node: {
                  __typename?: 'EntityRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          } | null;
          risks: {
            __typename?: 'AddressRiskConnection';
            totalCount: number;
            pageInfo: {
              __typename?: 'PageInfo';
              hasNextPage: boolean;
              hasPreviousPage: boolean;
              startCursor?: string | null;
              endCursor?: string | null;
            };
            edges: Array<{
              __typename?: 'AddressRiskEdge';
              node: {
                __typename?: 'AddressRisk';
                id: any;
                riskType: string;
                severity: string;
                description?: string | null;
              };
            }>;
          };
        } | null;
        from: {
          __typename?: 'Address';
          address: string;
          entity?: {
            __typename?: 'Entity';
            id: any;
            name: string;
            risks: {
              __typename?: 'EntityRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'EntityRiskEdge';
                node: {
                  __typename?: 'EntityRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          } | null;
          risks: {
            __typename?: 'AddressRiskConnection';
            totalCount: number;
            pageInfo: {
              __typename?: 'PageInfo';
              hasNextPage: boolean;
              hasPreviousPage: boolean;
              startCursor?: string | null;
              endCursor?: string | null;
            };
            edges: Array<{
              __typename?: 'AddressRiskEdge';
              node: {
                __typename?: 'AddressRisk';
                id: any;
                riskType: string;
                severity: string;
                description?: string | null;
              };
            }>;
          };
        };
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  };
};

export const GetTransactionsDocument = gql`
  query GetTransactions(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: [FilterInput!]
  ) {
    transactions(
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          hash
          nonce
          transactionIndex
          to {
            ...AddressDisplay
          }
          from {
            ...AddressDisplay
          }
          value
          valueEth
          valueUsd
          gas
          gasPrice
          maxFeePerGas
          maxPriorityFeePerGas
          maxFeePerBlobGas
          input
          chainId
          status
          blockNumber
          blockHash
          createdAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
  ${AddressDisplayFragmentDoc}
`;

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTransactionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTransactionsQuery,
    GetTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(
    GetTransactionsDocument,
    options,
  );
}
export function useGetTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTransactionsQuery,
    GetTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTransactionsQuery,
    GetTransactionsQueryVariables
  >(GetTransactionsDocument, options);
}
export function useGetTransactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTransactionsQuery,
        GetTransactionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTransactionsQuery,
    GetTransactionsQueryVariables
  >(GetTransactionsDocument, options);
}
export type GetTransactionsQueryHookResult = ReturnType<
  typeof useGetTransactionsQuery
>;
export type GetTransactionsLazyQueryHookResult = ReturnType<
  typeof useGetTransactionsLazyQuery
>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<
  typeof useGetTransactionsSuspenseQuery
>;
export type GetTransactionsQueryResult = Apollo.QueryResult<
  GetTransactionsQuery,
  GetTransactionsQueryVariables
>;
